import { render } from "./MenuGrid.vue?vue&type=template&id=5774786e&scoped=true"
import script from "./MenuGrid.vue?vue&type=script&lang=js"
export * from "./MenuGrid.vue?vue&type=script&lang=js"

import "./MenuGrid.vue?vue&type=style&index=0&id=5774786e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5774786e"]])

export default __exports__